import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-growth-menu',
  templateUrl: './growth-menu.component.html',
  styleUrls: ['./growth-menu.component.scss']
})
export class GrowthMenuComponent implements OnInit {
  @Input() public valueScheme;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal,) { }

  ngOnInit() {
  }
  passBack=(e)=> {
    this.passEntry.emit(e.target.value);
    this.activeModal.close();
  }
 
}
